<!--

MapWrapper
----------

-->

<template>
    <div class="map-container">
        <div :id="id" class="map"></div>
    </div>
</template>

<style lang="scss" scoped>

.map, .map-container {
    width: 100%;
    height: 100%;
}

</style>

<script>
    import * as uuidv1 from 'uuid/v1'
    import {loadEndCallback} from '../../modules/map/loader.js'
    import * as MapInterface from '../../modules/map/interface.js'
    import {buildSources, getSourceById} from '../../modules/map/sources.js'

    export default {
        mounted: function() {
            loadEndCallback(() => {
                this.$emit('map-loadend', this.id)
            })
            buildSources()
            const source = getSourceById(this.source)
            MapInterface.buildMap(this.id, source)
            MapInterface.setPadding(this.padding)
        },
        props: {
            padding: {
                type: Number,
                default: 20
            },
            maxZoom: {
                type: Number,
                default: 18
            },
        },
        computed: {
            source() {
                return this.$store.state.map.activeSource
            }
        },
        data: function() {
            return {
                id: uuidv1(),
            }
        },
    }
</script>